let load = require('./helpers/browser/esm-js-loader-shards')(4);
module.exports = (load("AJZU5")).then(() => parcelRequire('a7My1'));